// Packages
import tw, { styled } from "twin.macro";

// Images
// import HeroBg from "../../_images/full_background.webp";
// import HeroBgSml from "../../_images/full_background_small.jpg";

export const Main = styled.main(() => [
  `background-color:#f8f9f7;`,
  // `@media screen and (min-width: 768px) {background-image: url("${HeroBg}"); background-size: 100vw auto}`,
  tw` text-gray-700 relative min-h-screen overflow-x-hidden `
]);

export const Container = styled.div(() => [
  ``,
  tw`container mx-auto px-4 relative z-10`
]);
